module.exports = __webpack_public_path__ + "static/img/bg-review-story.7754475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_new/bg-review-story.jpg
// module id = pvhP
// module chunks = 0